import { ScriptMap } from "./tools";

/**
 * Defines the interface that exposes all exported scripts in this project.
 */
export interface ISceneScriptMap {
	"src/scenes/scene/applyShadowMaterial.ts": ScriptMap;
	"src/scenes/scene/playAnimation.ts": ScriptMap;
}

/**
 * Defines the map of all available scripts in the project.
 */
export const scriptsMap: ISceneScriptMap = {
	"src/scenes/scene/applyShadowMaterial.ts": require("./scene/applyShadowMaterial"),
	"src/scenes/scene/playAnimation.ts": require("./scene/playAnimation"),
}
